












import {Component, Prop, Vue} from 'vue-property-decorator';
import {WebService} from '../../../services';
import type {ILandingPageElementImage} from '../../../store';
import type {ILBElementComponent} from '../../../types';


@Component
export default class LBElementImage extends Vue implements ILBElementComponent {
	@Prop({required: true})
	element!: ILandingPageElementImage;

	get imgSrc() {
		return `${WebService.defaultHost}/${this.element.value.imgSrc}`;
	}

	loading = true;

	/*
	 * QImg's own loading indicator isn't performing as expected. It shows up
	 * too late to give an indication (especially in Web Admin's Layout Builder)
	 * that the image is present and loading. Instead, reserve a minimum height
	 * of 50px to hold a QInnerLoading spinner. Once the QImg has loaded, remove
	 * the outer spinner and the defined min-height.
	 */
	loaded() {
		this.loading = false;
	}
}
